import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-tab-switcher',
  templateUrl: './tab-switcher.component.html',
  styleUrls: ['./tab-switcher.component.scss']
})
export class TabSwitcherComponent {
  @Input() tabs: any[] = [];
  @Input() label: string;
  @Input() right: string;
  @Output() tabChangedEvent = new EventEmitter<number>();
  @ViewChild('nav') nav : any;
  isCollapsed = false;
  activeTab: number = 1;

  ngOnInit() {
    if (this.tabs?.length > 0) {
      this.activeTab = this.tabs[0].id || 1;
    }
  }

  tabChanged(tabId: number) {
    this.activeTab = tabId;
    this.tabChangedEvent.emit(tabId);
  }

  toggleSidebar(){
    this.isCollapsed = !this.isCollapsed;
  }
}
